import { render, staticRenderFns } from "./TeacherEdit.vue?vue&type=template&id=6c016751&"
import script from "./TeacherEdit.js?vue&type=script&lang=js&"
export * from "./TeacherEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports